// Most codes here are validator findings (docs/automation-architecture.md §3.3): they travel
// as items of `flows.invalid_graph` details and as canvas hints, and are thrown on their own
// only where one finding is the whole answer (an edge the canvas refused). Platform maps them.
export const FlowsErrorCodes = {
  INVALID_GRAPH: 'flows.invalid_graph',
  GRAPH_SHAPE_INVALID: 'flows.graph_shape_invalid',
  TOO_MANY_NODES: 'flows.too_many_nodes',
  TOO_MANY_EDGES: 'flows.too_many_edges',
  DUPLICATE_NODE_KEY: 'flows.duplicate_node_key',
  UNKNOWN_NODE_TYPE: 'flows.unknown_node_type',
  NODE_CONFIG_INVALID: 'flows.node_config_invalid',
  NODE_CONFIG_REQUIRED: 'flows.node_config_required',
  RETRY_NOT_SUPPORTED: 'flows.retry_not_supported',
  TRIGGER_MISSING: 'flows.trigger_missing',
  TRIGGER_MULTIPLE: 'flows.trigger_multiple',
  TRIGGER_HAS_INPUT: 'flows.trigger_has_input',
  TRIGGER_NOT_AT_ROOT: 'flows.trigger_not_at_root',
  NOTHING_AFTER_TRIGGER: 'flows.nothing_after_trigger',
  NODE_UNREACHABLE: 'flows.node_unreachable',
  EDGE_UNKNOWN_NODE: 'flows.edge_unknown_node',
  EDGE_UNKNOWN_OUTPUT: 'flows.edge_unknown_output',
  EDGE_UNKNOWN_INPUT: 'flows.edge_unknown_input',
  EDGE_DUPLICATE: 'flows.edge_duplicate',
  EDGE_TO_SELF: 'flows.edge_to_self',
  EDGE_HANDLED_NOT_ERROR: 'flows.edge_handled_not_error',
  EDGE_CREATES_CYCLE: 'flows.edge_creates_cycle',
  MERGE_INPUT_UNCONNECTED: 'flows.merge_input_unconnected',
  MERGE_INPUTS_EXCLUSIVE: 'flows.merge_inputs_exclusive',
  ERROR_UNHANDLED_WITHOUT_RETRY: 'flows.error_unhandled_without_retry',
  NODE_WITHOUT_TRAFFIC: 'flows.node_without_traffic',
  DEDUPE_BELOW_SPLIT: 'flows.dedupe_below_split',
  AGGREGATE_WITHOUT_SPLIT: 'flows.aggregate_without_split',
  SPLIT_LEAVES_LOOP: 'flows.split_leaves_loop',
  NODE_CANNOT_BE_DISABLED: 'flows.node_cannot_be_disabled',
  DISABLED_SKIPS_BRANCH: 'flows.disabled_skips_branch',
  REF_NOT_FOUND: 'flows.ref_not_found',
  TOO_MANY_ISSUES: 'flows.too_many_issues',
  PUBLISH_CONFLICT: 'flows.publish_conflict',
  RUN_LIMIT_EXCEEDED: 'flows.run_limit_exceeded',
  TEST_NEEDS_UPSTREAM: 'flows.test_needs_upstream',
  LOOP_CHILD_UNKNOWN: 'flows.loop_child_unknown',
  LOOP_CHILD_SHARED: 'flows.loop_child_shared',
  LOOP_CHILDREN_ON_NON_LOOP: 'flows.loop_children_on_non_loop',
  LOOP_NESTING_TOO_DEEP: 'flows.loop_nesting_too_deep',
  LOOP_BODY_EMPTY: 'flows.loop_body_empty',
  LOOP_BODY_ENTRY: 'flows.loop_body_entry',
  LOOP_BODY_EXIT: 'flows.loop_body_exit',
  LOOP_BODY_NEEDS_MERGE: 'flows.loop_body_needs_merge',
  LOOP_EDGE_CROSSES_BOUNDARY: 'flows.loop_edge_crosses_boundary',
  TEMPLATE_INVALID: 'flows.template_invalid',
  TEMPLATE_MISSING_NODE: 'flows.template_missing_node',
  TEMPLATE_SELF_REFERENCE: 'flows.template_self_reference',
  TEMPLATE_DOWNSTREAM: 'flows.template_downstream',
  TEMPLATE_PARALLEL_BRANCH: 'flows.template_parallel_branch',
  TEMPLATE_OTHER_BRANCH: 'flows.template_other_branch',
  TEMPLATE_NOT_ON_EVERY_PATH: 'flows.template_not_on_every_path',
  TEMPLATE_INSIDE_LOOP: 'flows.template_inside_loop',
  TEMPLATE_ITEM_OUTSIDE_SPLIT: 'flows.template_item_outside_split',
  TEMPLATE_LOOP_OUTSIDE_LOOP: 'flows.template_loop_outside_loop',
  TEMPLATE_AFTER_AGGREGATE: 'flows.template_after_aggregate',
  TEMPLATE_DISABLED_NODE: 'flows.template_disabled_node',
  CONDITION_INVALID: 'flows.condition_invalid',
  RETENTION_BELOW_COPY_LIFETIME: 'flows.retention_below_copy_lifetime',
  NODE_TYPE_UNAVAILABLE: 'flows.node_type_unavailable',
  JOIN_TIMED_OUT: 'flows.join_timed_out',
  LOOP_LIMIT_REACHED: 'flows.loop_limit_reached',
  LOOP_BODY_LEFT: 'flows.loop_body_left',
  FLOW_NOT_FOUND: 'flows.flow_not_found',
  COPY_NOT_RETRYABLE: 'flows.copy_not_retryable',
  COPY_ALREADY_REDELIVERED: 'flows.copy_already_redelivered',
  RETRY_AFTER_JOIN_FIRED: 'flows.retry_after_join_fired',
  CONTENT_REMOVED: 'flows.content_removed',
  QUEUE_DEAD: 'flows.queue_dead',
  ACTION_INPUT_INVALID: 'flows.action_input_invalid',
  URL_NOT_ALLOWED: 'flows.url_not_allowed',
  CODE_INVALID: 'flows.code_invalid',
  CODE_SIGNATURE_MISMATCH: 'flows.code_signature_mismatch',
  PROMPT_VARIABLE_UNBOUND: 'flows.prompt_variable_unbound',
  PROMPT_VARIABLE_UNKNOWN: 'flows.prompt_variable_unknown',
  NOT_PUBLISHED: 'flows.not_published',
  NODE_NOT_FOUND: 'flows.node_not_found',
  NODE_NOT_TESTABLE: 'flows.node_not_testable',
  TEST_SAMPLE_MISSING: 'flows.test_sample_missing',
  BACKTEST_NOT_CONDITION: 'flows.backtest_not_condition',
  DRAFT_CONFLICT: 'flows.draft_conflict',
  ENGINE_DISABLED: 'flows.engine_disabled',
  // The HTTP surface (phase 5, docs/flows-api.md).
  GRAPH_TOO_LARGE: 'flows.graph_too_large',
  CREATE_NEEDS_GRAPH_OR_PAIR: 'flows.create_needs_graph_or_pair',
  STATE_UNCHANGED: 'flows.state_unchanged',
  FLOW_DISABLED: 'flows.flow_disabled',
  FLOW_HAS_OPEN_COPIES: 'flows.flow_has_open_copies',
  FLOW_HAS_WAITING_COPIES: 'flows.flow_has_waiting_copies',
  VERSION_NOT_FOUND: 'flows.version_not_found',
  RUN_NOT_FOUND: 'flows.run_not_found',
  COPY_NOT_FOUND: 'flows.copy_not_found',
  RUN_NOT_REPLAYABLE: 'flows.run_not_replayable',
  RUN_NOT_BOOKMARKABLE: 'flows.run_not_bookmarkable',
  TEST_RATE_LIMITED: 'flows.test_rate_limited',
  NOTHING_TO_PUBLISH: 'flows.nothing_to_publish',
  NOTHING_TO_CARRY_OVER: 'flows.nothing_to_carry_over',
  TEST_IN_PROGRESS: 'flows.test_in_progress',
  TEST_SAMPLES_STALE: 'flows.test_samples_stale',
  SCHEDULE_QUOTA_EXCEEDED: 'flows.schedule_quota_exceeded',
  SCHEDULE_SKIPPING: 'flows.schedule_skipping',
  NAME_TAKEN: 'flows.name_taken',
  TEST_REQUEST_NOT_FOUND: 'flows.test_request_not_found',
  MANUAL_INPUT_INVALID: 'flows.manual_input_invalid',
  // The `ai.agent` step's findings (agents-architecture §3.3).
  AGENT_PICK_MODEL: 'agents.pick_model',
  AGENT_CREDENTIAL_NOT_AI: 'agents.credential_not_ai',
  AGENT_COST_LIMIT_UNPRICED: 'agents.cost_limit_unpriced',
  AGENT_TOOL_NAME_RESERVED: 'agents.tool_name_reserved',
  AGENT_TOOL_HOST_NOT_FIXED: 'agents.tool_host_not_fixed',
  AGENT_TOOL_CHANGES_DATA_AUTO: 'agents.tool_changes_data_auto',
  AGENT_TOOL_FIELD_UNKNOWN: 'agents.tool_field_unknown',
  AGENT_TOOL_FIELD_UNSET: 'agents.tool_field_unset',
  AGENT_TOOL_INPUT_INVALID: 'agents.tool_input_invalid',
  AGENT_INSTRUCTIONS_TOOL_ROOT: 'agents.instructions_tool_root',
  AGENT_ASK_UNAVAILABLE: 'agents.ask_unavailable',
  AGENT_MEMORY_UNAVAILABLE: 'agents.memory_unavailable',
  AGENT_RUN_FLOW_INVALID: 'agents.run_flow_invalid',
  AGENT_RUN_FLOW_SELF: 'agents.run_flow_self',
  AGENT_CODE_MISSING: 'agents.code_missing',
  AGENT_FLOW_IN_USE: 'agents.flow_in_use',
  AGENT_TEST_NOT_FOUND: 'agents.test_not_found',
  AGENT_TEST_FINISHED: 'agents.test_finished',
  AGENT_SESSION_NOT_FOUND: 'agents.session_not_found',
  AGENT_STEP_NOT_FOUND: 'agents.step_not_found',
  AGENT_CONFIG_INVALID: 'agents.config_invalid',
  AGENT_DISABLED: 'agents.disabled',
} as const;

export type TFlowsErrorCode = (typeof FlowsErrorCodes)[keyof typeof FlowsErrorCodes];
